var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-8" }, [
        _vm._m(0),
        _c("h3", { staticClass: "subtitle" }, [_vm._v(_vm._s(_vm.dataID))])
      ]),
      _c("div", { staticClass: "column is-4" })
    ]),
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-2" }, [
          _vm._v("\n                Quotation Ref.\n            ")
        ]),
        _c("div", { staticClass: "column is-4" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.quData.quRef,
                expression: "quData.quRef"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", name: "", id: "" },
            domProps: { value: _vm.quData.quRef },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.quData, "quRef", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-2" }, [
          _vm._v("\n                Lead Time\n            ")
        ]),
        _c("div", { staticClass: "column is-4" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.quData.leadTime,
                expression: "quData.leadTime"
              }
            ],
            staticClass: "input",
            attrs: { type: "number", name: "", id: "" },
            domProps: { value: _vm.quData.leadTime },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.quData, "leadTime", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-2" }, [
          _vm._v("\n                Amount (THB)\n            ")
        ]),
        _c("div", { staticClass: "column is-4" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.quData.amount,
                expression: "quData.amount"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", name: "", id: "" },
            domProps: { value: _vm.quData.amount },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.quData, "amount", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [_c("upload", { ref: "upload", attrs: { isMultiple: false } })],
          1
        )
      ])
    ]),
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-2" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Task Name")]),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.taskDetail.taskName,
                    expression: "taskDetail.taskName"
                  }
                ],
                staticClass: "input",
                attrs: { type: "text", placeholder: "" },
                domProps: { value: _vm.taskDetail.taskName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.taskDetail, "taskName", $event.target.value)
                  }
                }
              })
            ])
          ])
        ]),
        _c("div", { staticClass: "column is-5" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Task Detail")]),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.taskDetail.taskDetail,
                    expression: "taskDetail.taskDetail"
                  }
                ],
                staticClass: "input",
                attrs: { type: "text", placeholder: "" },
                domProps: { value: _vm.taskDetail.taskDetail },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.taskDetail, "taskDetail", $event.target.value)
                  }
                }
              })
            ])
          ])
        ]),
        _c("div", { staticClass: "column is-2" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Est.Start Date")]),
            _c(
              "div",
              { staticClass: "control" },
              [
                _c("datepicker", {
                  attrs: {
                    "input-class": "input",
                    language: "en",
                    format: "dd/MM/yyyy",
                    id: "estStatDate",
                    name: "estStatDate"
                  },
                  model: {
                    value: _vm.taskDetail.estStartDate,
                    callback: function($$v) {
                      _vm.$set(_vm.taskDetail, "estStartDate", $$v)
                    },
                    expression: "taskDetail.estStartDate"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _c("div", { staticClass: "column is-2" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Est.Finish Date")]),
            _c(
              "div",
              { staticClass: "control" },
              [
                _c("datepicker", {
                  attrs: {
                    "input-class": "input",
                    language: "en",
                    format: "dd/MM/yyyy",
                    id: "estFinishDate",
                    name: "estFinishDate"
                  },
                  model: {
                    value: _vm.taskDetail.estFinishDate,
                    callback: function($$v) {
                      _vm.$set(_vm.taskDetail, "estFinishDate", $$v)
                    },
                    expression: "taskDetail.estFinishDate"
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-12" }, [
          _c(
            "button",
            {
              staticClass: "button is-primary",
              on: {
                click: function($event) {
                  _vm.addTaskConfig()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-check" }), _vm._v(" Add New Task")]
          )
        ])
      ])
    ]),
    _vm.quData.quotationTask.length > 0
      ? _c("div", [
          _c("table", { staticClass: "table" }, [
            _vm._m(1),
            _c(
              "tbody",
              _vm._l(_vm.quData.quotationTask, function(item, index) {
                return _c("tr", { key: item.taskName }, [
                  _vm._m(2, true),
                  _c("td", [_vm._v(_vm._s(item.taskName))]),
                  _c("td", [_vm._v(_vm._s(item.taskDetail))]),
                  _c("td", [_vm._v(_vm._s(_vm._f("Date")(item.estStartDate)))]),
                  _c("td", [
                    _vm._v(_vm._s(_vm._f("Date")(item.estFinishDate)))
                  ]),
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "button is-small is-danger",
                        on: {
                          click: function($event) {
                            _vm.deleteTask(index)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-trash" }),
                        _vm._v(" Delete")
                      ]
                    )
                  ])
                ])
              })
            )
          ])
        ])
      : _vm._e(),
    _vm.quData.quotationTask.length > 0
      ? _c("article", {}, [
          _vm._m(3),
          _c(
            "div",
            {},
            [_c("grantchart", { attrs: { tasks: _vm.quData.quotationTask } })],
            1
          )
        ])
      : _vm._e(),
    _c("div", [
      _c(
        "div",
        { staticClass: "is-pulled-right" },
        [
          _c("isButton", {
            ref: "btnCreate",
            attrs: {
              onClick: _vm.createQutation,
              state: "true",
              title: "Create"
            }
          })
        ],
        1
      )
    ]),
    _c("br"),
    _c("br")
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "title" }, [
      _c("b", [
        _c("i", { staticClass: "fa fa-file" }),
        _vm._v(" Create New Quotation")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _c("th", [_vm._v("Task Name")]),
        _c("th", [_vm._v("Task Detail")]),
        _c("th", [_vm._v("Est. Start Date")]),
        _c("th", [_vm._v("Est. Finish Date")]),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("i", { staticClass: "fa fa-tasks" }),
      _vm._v(" \n                    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "message-section is-clearfix clear-margin-bottom",
        staticStyle: { "border-bottom": "none" }
      },
      [_c("p", [_vm._v("Task")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-200d6147", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-200d6147","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/quotation/create-revise.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-200d6147","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/quotation/create-revise.vue
// module chunks = 31